/** Plan descriptions. Plan names (Starter, Pro, Elite) are not translated. */
export default {
  period: "one-time",
  creditsIncluded_one: "{{count}} point",
  creditsIncluded_other: "{{count}} points",
  /** The volume-free perks a custom amount reaching each level gets. */
  benefits: {
    starter: ["Commercial usage license", "Email support"],
    pro: ["Commercial usage license", "Priority email support"],
    elite: ["Commercial usage license", "Priority email and phone support"],
    studio: ["Everything in Elite", "Dedicated account manager", "Custom invoicing"],
  },
  starter: {
    tagline: "For creators getting started with AI visuals.",
    cta: "Start with Starter",
    features: [
      "20 points — up to 20 images or 10 video clips",
      "Images up to 1024 × 1024 px",
      "Video clips up to Full HD (1080p)",
      "Commercial usage license",
      "Email support",
    ],
  },
  pro: {
    tagline: "For professionals who need speed and polish.",
    cta: "Go Pro",
    features: [
      "100 points — up to 100 images or 50 video clips",
      "Images up to 1024 × 1024 px",
      "Video clips up to Full HD (1080p)",
      "Commercial usage license",
      "Priority email support",
    ],
  },
  elite: {
    tagline: "For studios and teams at full scale.",
    cta: "Scale with Elite",
    features: [
      "300 points — up to 300 images or 150 video clips",
      "Images up to 1024 × 1024 px",
      "Video clips up to Full HD (1080p)",
      "Commercial usage license",
      "Priority email and phone support",
    ],
  },
};
